import PermissionControllProvider from "@/application/providers/PermissionControllProvider"

function PemissionControllService() {
    this.getAccessProfiles = () => PermissionControllProvider.getAccessProfiles();

    this.getUsersByAccessProfile = ({NRPERFILACESSO}) => PermissionControllProvider.getUsersByAccessProfile(NRPERFILACESSO);

    this.getAccessProfilesPermissions = (profileID) => {
        let dataPromise;
        dataPromise = profileID ? PermissionControllProvider.getAccessProfilesPermissions(profileID) 
            : Promise.resolve([])
        return dataPromise
    };

    this.saveAccessProfilePermission = (profileID, permissionID) => {
        return PermissionControllProvider.saveAccessProfilePermission(profileID, permissionID);
    };
    
    this.removeAccessProfilePermission = (accessProfilePermissionID) => {
        return PermissionControllProvider.removeAccessProfilePermission(accessProfilePermissionID);
    };
    
    this.grantAllPermissionToAccessProfile = (accessProfilePermissionID, permissions) => {
        const newPermissions = permissions.filter(p => p.ATIVO === 'N');
        const newPermissionsStr = `_${newPermissions.map(np => np.NROTIMIZADORITEM).join("_")}_`;
        return PermissionControllProvider.grantAllPermissionToAccessProfile(accessProfilePermissionID, 
            newPermissionsStr, newPermissions.length);
    };
    
    this.revokeAllPermissionToAccessProfile =  (permissions) => {
        const newPermissions = permissions.filter(p => p.ATIVO === 'S');
        const newPermissionsStr = `_${newPermissions.map(np => np.NROTIMIZADORITEMPER).join("_")}_`;
        return PermissionControllProvider.revokeAllPermissionToAccessProfile(newPermissionsStr);
    };
}

export default new PemissionControllService();